import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase/config';
import { 
  setProfile,
  logout,
  authHydrated,
  requireProfileSetup,
  resolveIsAdmin
} from '../features/auth/authSlice';
import { apiService } from '../services/api';

export const listenToAuthChanges = (store) => {
  onAuthStateChanged(auth, async (firebaseUser) => {
    if (firebaseUser) {
      try {
        const profile = await apiService.getMyProfile();
        const isAdmin = await resolveIsAdmin(profile);
        store.dispatch(setProfile({ ...profile, isAdmin }));
      } catch (error) {
        if (error.response && error.response.status === 404) {
          store.dispatch(requireProfileSetup());
        } else {
          console.error('Auth listener error:', error);
          store.dispatch(logout());
        }
      }
    } else {
      store.dispatch(logout());
    }
    store.dispatch(authHydrated());
  });
};